export default __webpack_public_path__ + "static/media/curve.4fa59637.svg";